import Device from '../../../../../../../constants/deviceSizes';
import { appConfig } from '../../../../../../../config/customization';

export default {
  title: {
    width: '100%'
  },
  container: {
    width: '100%'
  },
  itemContentContainer: {
    textAlign: 'justify',
    paddingTop: 4,
    zIndex: 1,
    width: '70%',
    [Device.mobile]: {
      width: '100%'
    }
  },
  innerContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 20
  },
  contactContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 20
  },
  contactLabel: {
    paddingTop: 20
  },
  sideImage: {
    height: 125,
    marginRight: 15,
    [Device.mobile]: {
      display: 'none'
    }
  },
  minPadding: {
    paddingTop: 0
  },
  hr: {
    borderColor: appConfig.colors.lightGray,
    width: '75%',
    display: 'inline-block',
    [Device.mobile]: {
      width: '90%'
    }
  },

  lightBlue: {
    color: appConfig.colors.socialRateLightBlue
  },

  blue: {
    color: appConfig.colors.socialRateBlue
  },

  darkBlue: {
    color: appConfig.colors.socialRateDarkBlue
  }
};
